import { defineMessages } from "react-intl";

export const PageContentBoxText = defineMessages({
  formHeaderLogoAlt: {
    defaultMessage: "Form logo",
    id: "lLn7gv",
  },
});
